export const useEventListener = () => {
  /** 중심 변경 이벤트 리스너 처리 */
  let centerChangedListener: any = null;

  const addCenterChangedEventListener = (map: any, callBack: () => void) => {
    centerChangedListener = window.naver.maps.Event.addListener(
      map,
      "center_changed",
      callBack
    );
  };

  const removeCenterChangedEventListener = () => {
    window.naver.maps.Event.removeListener(centerChangedListener);
    centerChangedListener = null;
  };

  /** 마커 클릭 이벤트 리스너 처리 */
  let markerClickListener: any = null;

  const addMarkerClickEventListener = (marker: any, callBack: () => void) => {
    markerClickListener = window.naver.maps.Event.addListener(
      marker,
      "click",
      callBack
    );
  };

  const removeMarkerClickEventListener = () => {
    window.naver.maps.Event.removeListener(markerClickListener);
    markerClickListener = null;
  };

  /** 드래그 이벤트 리스너 처리 */
  let dragListener: any = null;

  const addDragListener = (map: any, callBack: () => void) => {
    dragListener = window.naver.maps.Event.addListener(map, "drag", callBack);
  };

  const removeDragEventListener = () => {
    if (dragListener) {
      window.naver.maps.Event.removeListener(dragListener);
      dragListener = null;
    }
  };

  /** 드래그 종료 이벤트 리스너 처리 */
  let dragEndListener: any = null;

  const addDragEndEventListener = (map: any, callBack: () => void) => {
    dragEndListener = window.naver.maps.Event.addListener(
      map,
      "dragend",
      callBack
    );
  };

  const removeDragEndEventListener = () => {
    if (dragEndListener) {
      window.naver.maps.Event.removeListener(dragEndListener);
      dragEndListener = null;
    }
  };

  /** zoom 변경 완료 이벤트 리스너 처리 */
  let zoomChangedListener: any = null;

  const addZoomChangedEventListener = (map: any, callBack: () => void) => {
    zoomChangedListener = window.naver.maps.Event.addListener(
      map,
      "zoom_changed",
      callBack
    );
  };

  const removeZoomChangedEventListener = () => {
    if (zoomChangedListener) {
      window.naver.maps.Event.removeListener(zoomChangedListener);
      zoomChangedListener = null;
    }
  };

  /** idle 이벤트 리스너 처리 - 지도가 완전히 정지했을 때 */
  let idleListener: any = null;

  const addIdleEventListener = (map: any, callBack: () => void) => {
    idleListener = window.naver.maps.Event.addListener(map, "idle", callBack);
  };

  const removeIdleEventListener = () => {
    if (idleListener) {
      window.naver.maps.Event.removeListener(idleListener);
      idleListener = null;
    }
  };

  return {
    addCenterChangedEventListener,
    removeCenterChangedEventListener,
    addMarkerClickEventListener,
    removeMarkerClickEventListener,
    addDragListener,
    removeDragEventListener,
    addDragEndEventListener,
    removeDragEndEventListener,
    addZoomChangedEventListener,
    removeZoomChangedEventListener,
    addIdleEventListener,
    removeIdleEventListener,
  };
};
